import { useContext } from 'react';

import AgronomyAgreementServicesContext from './AgronomyAgreementServicesContext';

const useAgronomyAgreementServices = () => {
  return useContext(AgronomyAgreementServicesContext);
};

export default useAgronomyAgreementServices;
